export const PHONE_CONTACT_POINT_KINDS = ["MOBILE", "FIXED_LINE"] as const

export type PhoneContactPointKind = (typeof PHONE_CONTACT_POINT_KINDS)[number]

const normalizeText = (value: unknown) => `${value ?? ""}`.trim().toUpperCase()

export const isPhoneContactPointKind = (kind: unknown): kind is PhoneContactPointKind =>
  PHONE_CONTACT_POINT_KINDS.includes(normalizeText(kind) as PhoneContactPointKind)

export const isMobileContactPointKind = (kind: unknown): kind is "MOBILE" =>
  normalizeText(kind) === "MOBILE"

export const contactPointKindLabel = (kind: unknown) => {
  const normalized = normalizeText(kind)

  if (normalized === "EMAIL") return "E-Mail"

  if (normalized === "MOBILE") return "Mobil"

  if (normalized === "FIXED_LINE") return "Festnetz"

  if (normalized === "ADDRESS") return "Adresse"

  return normalized || "Kontaktpunkt"
}

export const contactPointKindOptions = [
  { name: "E-Mail", value: "EMAIL" },
  { name: "Mobil", value: "MOBILE" },
  { name: "Festnetz", value: "FIXED_LINE" },
  { name: "Adresse", value: "ADDRESS" },
] satisfies Array<{ name: string; value: ContactPointKind }>
